import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!form.email.trim() || !form.password.trim()) {
      setError("Email and password are required.");
      return;
    }

    try {
      setLoading(true);
      const user = await login({
        email: form.email,
        password: form.password
      });
      const dashboardRoute = user.role === "admin" ? "/admin/queue" : "/account";

      if (location.state?.openPostProperty) {
        navigate(dashboardRoute, {
          state: {
            openPostProperty: true,
            selectedType: location.state?.selectedType,
            listingType: location.state?.listingType,
            postPropertySource: "dashboard",
            message: "Welcome back. Continue completing your property details."
          }
        });
        return;
      }

      navigate(dashboardRoute);
    } catch (requestError) {
      const message =
        requestError?.response?.data?.detail || "Login failed. Please check your credentials.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h2>Welcome Back</h2>
        <p className="auth-subtitle">Sign in to manage and browse property listings.</p>

        {location.state?.prompt ? <div className="feedback-banner info-banner">{location.state.prompt}</div> : null}
        {error ? <div className="feedback-banner error-banner">{error}</div> : null}

        <form onSubmit={onSubmit}>
          <input
            className="auth-input"
            type="email"
            name="email"
            placeholder="Email address"
            value={form.email}
            onChange={onChange}
          />

          <input
            className="auth-input"
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={onChange}
          />

          <button className="auth-btn" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        <div className="auth-footer">
          Don’t have an account? <Link to="/register" state={location.state}>Create one</Link>
        </div>
      </div>
    </div>
  );
}
